/** @jsx jsx */
import { jsx } from '@emotion/react'
import { Fragment } from 'react'
import { Parallax } from 'react-parallax';
import BgSection from "../assets/images/LP-kingdom/header-educacao-infantil.png";

import { HeaderSection } from '../assets/styles/AboutTwo.styles'

const CtaContent = () => {

  return (
    <Fragment>
      <Parallax bgImage={BgSection} bgImageAlt="Educação Infantil" strength={100}>
        <section css={HeaderSection}>
          <div className="div-align">
            <h1>Educação Infantil</h1>
          </div>
          <div className="parallax-element"></div>
        </section>
      </Parallax>
    </Fragment>
  )
}

export default CtaContent
